export default __webpack_public_path__ + "static/media/IMG_3075_2_11zon.54094b42.jpg";